import React from 'react';

// Components
import Content from '../content/Content';

const ExtraContent = (props) => {
  return <Content extra {...props} />;
};

export default ExtraContent;



/** WEBPACK FOOTER **
 ** ./src/components/layout/sui/contents/extraContent/ExtraContent.js
 **/